var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3113_931",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3113_931",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADQUlEQVR4nO2dO24UQRCGC18ALsBrd7vWASJBJCQ8IsQZDJG1VUNCgGULIbEIYeAEcAAfwOIEkGBfwHKGBKQgkAggMdtoekBisfeBdqarh/5/qaLd4O/6prurt3e6iSAIgiAIgiAIgiAIgiAoN7miQ05ukZM14mIji3BlW/Um8epZSkas14hll1h95rFD/eKqIYnhEjl5mkAifEIxIpbNkJvoAgw/GUwJJfowVT4N5k+kTzRGcYcvzBl+Dig7cWD05UwCT6BvR8SovsrS1ryh2pIoVpoHEmpw64ZqS6LYaB6Ik4f2DdV2RJkrAFF7EACi9skHELVPOICofZIBRO0TCyBqn0wASSCBALLIcKCvwo+cy8WFsaj2Z16n4TGbdYh8o87g+ESPp++cINbv5j4zArI/02f5HWufGQHZmwPInrlPAPlDAIIeQhn3kLczfZbfsfaZEZAfocSdCKO4mMSef2brkK/k5PnhP6/pi/CZtb/sgHALAkDUHgKAqH3iAUTtkw0gap9gAFH7pAKI2icSQBZNgnyoIgEIWZe9TrbDm1u/1Rt0yclLc19ZAnGyTUTHJrxIlAaUjICMxnrG3+re7iXgMSsg72f6TGFOyQeIYMcQQBQ9hNBDMGQR5hDMIYsJk7pHlcWostBDGOsQj3UI5hCPlTpW6jULVZZHlcWostBDGFWWR5WFOcSjyqqnytqf+SzhlbaoO3Gfpx80OVwili/mG2n57BiqJx5cn+Lxhr2/3IA4eUfd4uQhf53BqbDnbu0vOyAcXtr5SE7uUb+4FMLJfXLyydxXtkA48QAQtYcAIGqfeABR+2QDiNonGEDUPqkAovaJBJAEksdtBYKjxv38UGS9eSA4jN+ndRg/rqvw8wOJdVlYeVmJ9fjMiYeTNxRN5XU+KRx/xMnGiHrFZYoq1icJNNwnGU4eUXyFXblN9BQd7xmsj49+OziW+nIFc4pWc0b0YWqayoqiLPOqK0mf1RRbDQwnW7X5q06xWwmVZzZiWa8PiDywbs7/Ia4DCmCkdDvcsGY30AJQACMhKMNmzUD/AgUwosrJGrEeHAHigJzejWsGqsTF+XCSdbi9WnbDSdfLeu7XpxAEQRBEOekni50ozsmtMdcAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.efdc86f93abdc0f285d003def147319c.svg";
export { ForwardRef as ReactComponent };